import React from 'react';
import PropTypes from 'prop-types';

import 'login/components/Transaction/TransactionProgressBar/TransactionProgressBar.scss';

class TransactionProgressBar extends React.Component {
    render() {
        const percentage = `${this.props.percentage}%`;
        return (
            <div className="TransactionProgressBar--wrapper">
                <div className="TransactionProgressBar--progression" style={{ width: percentage }} />
            </div>
        );
    }
}

TransactionProgressBar.propTypes = {
    percentage: PropTypes.string.isRequired,
};

TransactionProgressBar.displayName = 'TransactionProgressBar';

export default TransactionProgressBar;
